import React,{ useState} from 'react';
import { useSelector, useDispatch, connect} from 'react-redux';
import * as actionsUser  from '../../../../app/actions/user';
import * as actionsPolicy  from '../../../../app/actions/policy';
import { NuInsInputTextLabel, NuInsInputNumLabel } from '../elements/inputFieldsLabel';
import { CheckBoxCustom } from '../elements/inputFields';
import NuInsStepper from '../elements/NuInsStepper';
import {steppLabels} from './common/types';
import {BackIcon} from '../svg/iconsSvg';
import { Divider, Loader } from 'rsuite';


const UserAddress = ({onBack, onForward, updateUserDetails, style}) => {

    const dispatch = useDispatch();

    const ownerDetails = useSelector(state => state.ownerDetails);
    const ownerAddress = ownerDetails.ownerAddress || {};

    const userDetails = useSelector(state => state.userDetails);
    const userAddress = userDetails.userAddress || {};

    const [loading, setLoading] = useState(false);
    const [checkFields, setCheckFields] = useState({});

    const [sameAsOwner, setSameAsOwner] = useState(false);

    //const inputFields = ['postalCode', 'city', 'streetName', 'streetNumber', 'apartmentBuilding', 'entrance', 'floor', 'apartment'];
    const inputFields = ['postalCode', 'city', 'streetName', 'streetNumber'];
    const errorMsg    = "Полето е задължително";

    const handleSameAsOwner = (data) => {
        if(data) updateUserDetails({userAddress: ownerAddress });
        setSameAsOwner(data);
    }

    const onChangeHandler = (field, data) =>  {
        updateUserDetails({userAddress: {...userAddress, [field]: data}});
    }

    const onBlurHandler = (field) =>  {
        setCheckFields({...checkFields, [field]: true});
    }

    const checkForLatin = (fieldValue) => {
        if (!fieldValue) return;
        return fieldValue.match(/[a-zA-Z]/) ? true : false;
    }

    const checkForError = (field, type, allFields) =>  {
        switch (type) {
            case 'cyrilic':
                const nonCyrFound = userAddress[field] ? checkForLatin(userAddress[field]) : false;
                return (checkFields[field] || allFields) && (nonCyrFound || !userAddress[field]);
            case 'zip':
                return (checkFields[field] || allFields) && (!userAddress[field] || (userAddress[field]?.length < 4));
            default:
                return (checkFields[field] || allFields) && !userAddress[field];
        }
    }

    const generateErrorMsg = (field, type) => {
        switch (type) {
            case 'cyrilic':
                return `${errorMsg} ${userAddress[field] ? 'на кирилица' : ''}`;
            case 'latin':
                return `${errorMsg} ${userAddress[field] ? 'на латиница' : ''}`;
            case 'zip':
                return `${errorMsg} ${userAddress[field] ? '4 символа' : ''}`;
            default:
                return errorMsg;
        }
    }

    const valdateAllFields = () => {

        for(let field of inputFields) {
            if(field.includes('Cyr')) {
                if(checkForError(field, 'cyrilic', true)) return false;
            } else if (field === 'postalCode') {
                if(checkForError(field, 'zip', true)) return false;
            } else {
                if(checkForError(field, null, true)) return false;
            }
        }

        return true;
    }

    const submitHandler = async () => {
        setCheckFields(inputFields.reduce((acc, field) => ({...acc, [field]: true}) , {}));

        if(valdateAllFields()) {
            setLoading(true);
            await dispatch(actionsPolicy.addUserAddress())
            setLoading(false);
            onForward(13);
        }
    }

    const goBack = () => {
        onBack(11)
    }

    return (
        <div className="steps_container" style={style}>
            <div className="head" style={{paddingTop: '0', marginBottom: '-18px'}}>
                <div className="head-icon" style={{margin: '0 -8px 0 4px'}} onClick={goBack}><BackIcon size={32}/></div>
                <NuInsStepper activeStep={4} steps={4} labels={steppLabels}/>
            </div>
            <Divider />
            {loading 
            ? <Loader backdrop center size="lg" speed="slow" /> 
            : <>
                <h6 style={{paddingLeft:"2rem", fontWeight: '500', marginTop: '8px', marginBottom: '20px' }}>Моят адрес </h6>
                
                <div className="steps_container-checkbox" style={{marginBottom: '20px'}}>
                    <CheckBoxCustom onChange={(data)=>handleSameAsOwner(data)} value={sameAsOwner} />
                    <div>Моят адрес съвпада с този на собственика</div>
                </div>
             
                <div className="address-container-one" style={{marginBottom: '20px'}}>
                <NuInsInputNumLabel onChange={(data)=>onChangeHandler('postalCode', data)} onBlur={()=>onBlurHandler('postalCode')}
                                    validationType={"noZero"} slice={4} 
                                    placeholder={"Пощенски код"} 
                                    value={userAddress?.postalCode}                                
                                    error={checkForError('postalCode', 'zip')} 
                                    errorMsg={generateErrorMsg('postalCode', 'zip')}/>
                </div>
                <NuInsInputTextLabel onChange={(data)=>onChangeHandler('city', data)} onBlur={()=>onBlurHandler('city')}
                                    placeholder={"Град"} 
                                    value={userAddress?.city}                                
                                    error={checkForError('city', 'cyrilic')} 
                                    errorMsg={generateErrorMsg('city', 'cyrilic')}
                                    styles={{marginBottom: '20px'}}/>
                
                <div className="address-container-three" style={{marginBottom: '20px'}}>
                    <NuInsInputTextLabel onChange={(data)=>onChangeHandler('streetName', data)} onBlur={()=>onBlurHandler('streetName')}
                                        placeholder={"ж.к. / кв. / ул. "} 
                                        value={userAddress?.streetName}                                
                                        error={checkForError('streetName', 'cyrilic')} 
                                        errorMsg={generateErrorMsg('streetName', 'cyrilic')}/>
                    <NuInsInputTextLabel onChange={(data)=>onChangeHandler('streetNumber', data)} onBlur={()=>onBlurHandler('streetNumber')}
                                        placeholder={"№"} 
                                        value={userAddress?.streetNumber}                                
                                        error={checkForError('streetNumber')} 
                                        errorMsg={generateErrorMsg('streetNumber')}/>
                    
                </div>
                <div className="address-container-two" style={{marginBottom: '20px'}}>
                    <NuInsInputTextLabel onChange={(data)=>onChangeHandler('apartmentBuilding', data)} onBlur={()=>onBlurHandler('apartmentBuilding')}
                                        placeholder={"Блок"} 
                                        value={userAddress?.apartmentBuilding}
                                        /* error={checkForError('apartmentBuilding')} 
                                        errorMsg={generateErrorMsg('apartmentBuilding')} */
                                        />
                    <NuInsInputTextLabel onChange={(data)=>onChangeHandler('entrance', data)} onBlur={()=>onBlurHandler('entrance')}
                                        placeholder={"Вход"} 
                                        value={userAddress?.entrance}                                
                                        /* error={checkForError('entrance')} 
                                        errorMsg={generateErrorMsg('entrance')} */
                                        />
                    <NuInsInputTextLabel onChange={(data)=>onChangeHandler('floor', data)} onBlur={()=>onBlurHandler('floor')}
                                        placeholder={"Етаж"} 
                                        value={userAddress?.floor}                                
                                        /* error={checkForError('floor')} 
                                        errorMsg={generateErrorMsg('floor')} */
                                        />
                    <NuInsInputTextLabel onChange={(data)=>onChangeHandler('apartment', data)} onBlur={()=>onBlurHandler('apartment')}
                                        placeholder={"Ап."} 
                                        value={userAddress?.apartment}                                
                                       /*  error={checkForError('apartment')} 
                                        errorMsg={generateErrorMsg('apartment')} */
                                        />
                </div>

                <button className="nuIns-btn nuIns-btn-mx nuIns-btn-main" type="submit" onClick={submitHandler}>Продължи</button>
            </>
            }
        </div>
    )
}

export default connect(null, {...actionsUser})(UserAddress);